<yat-icon
  [id]="id + '2d793b08-c99a-4004-8f48-72f5065e3388'"
  name="info-circle"
  #icon
  [ngClass]="iconClass"
  class="ico-tooltip"
  [yatTooltip]="tooltipContent"
  [tooltipClass]="tooltipClass"
  [appendToBody]="appendToBody"
  [tooltipPlacement]="tooltipPlacement"
  [centerPlacements]="true"
  [manualTooltip]="manualTooltip"
  data-html="true"
  (mouseenter)="mouseEnter.next(null)">
</yat-icon>
